import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";
import { Registration } from "../../models/registration";

@Component({
  selector: "registrationselection",
  templateUrl: "./registrationselection.component.html",
})
export class RegistrationSelectionComponent {
  @Input() public items: Registration[] = [];
  @Input() public selectedItem: Registration;
  @Output() public isSelected = new EventEmitter();
  @Output() public createNew = new EventEmitter();

  public getSelectedItemId(): string {
    if (this.selectedItem) {
      return this.selectedItem.id;
    } else {
      return "";
    }
  }

  public updateSelectedValue(id: string): void {
    this.selectedItem = this.items.find((myObj) => myObj.id === id);
    this.isSelected.emit(this.selectedItem);
  }

}
